import { Nilable } from "../shared/utils/Nullable";

export interface IRegionDTO {
    id: number;
    name: string;
    code: string;
}

export class RegionDTO {
    public id = 0;
    public nombre = "";
    public codigo = "";

    constructor(json: Nilable<Partial<IRegionDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IRegionDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.code != null) {
            this.codigo = json.code;
        }
    }

    public toJSON(): IRegionDTO {
        return {
            id: this.id,
            name: this.nombre,
            code: this.codigo
        };
    }
}
